import { render, staticRenderFns } from "./RiskAssessmentAlways.vue?vue&type=template&id=cc469c24&scoped=true"
import script from "./RiskAssessmentAlways.vue?vue&type=script&lang=js"
export * from "./RiskAssessmentAlways.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc469c24",
  null
  
)

export default component.exports